import { matchPath } from 'react-router-dom';

/** Bounded route name when no registered pattern matches (prevents cardinality inflation). */
export const UNMATCHED_ROUTE_PATTERN = '/:unmatched';

function normalizePattern(pattern: string): string {
  return pattern.startsWith('/') ? pattern : `/${pattern}`;
}

function fallbackRoutePattern(pathname: string): string {
  const path = pathname.split('?')[0] || '/';
  if (!path.split('/').filter(Boolean).length) return '/';
  return UNMATCHED_ROUTE_PATTERN;
}

function patternSpecificity(pattern: string) {
  const segments = pattern.split('/').filter(Boolean);
  const paramCount = segments.filter(segment => segment.startsWith(':')).length;
  return { segmentCount: segments.length, paramCount, length: pattern.length };
}

/**
 * Maps a concrete URL to a React Router pattern for New Relic SPA route tracking.
 */
export function pathnameToRoutePattern(pathname: string, routePatterns: string[]): string {
  const patterns = routePatterns.map(normalizePattern).sort((a, b) => {
    const aSpec = patternSpecificity(a);
    const bSpec = patternSpecificity(b);
    if (bSpec.segmentCount !== aSpec.segmentCount) return bSpec.segmentCount - aSpec.segmentCount;
    if (aSpec.paramCount !== bSpec.paramCount) return aSpec.paramCount - bSpec.paramCount;
    return bSpec.length - aSpec.length;
  });

  for (const pattern of patterns) {
    if (matchPath({ path: pattern, end: true }, pathname)) {
      return pattern;
    }
  }

  return fallbackRoutePattern(pathname);
}
